<nav class="navbar navbar-expand-lg navbar-light bg-light navbar-static-top">
  <a class="navbar-brand">Veracomp</a>
  <button class="navbar-toggler" type="button" data-toggle="collapse" data-target="#navbarSupportedContent" aria-controls="navbarSupportedContent" aria-expanded="false" aria-label="Toggle navigation">
    <span class="navbar-toggler-icon"></span>
  </button>

  <div class="collapse navbar-collapse" id="navbarSupportedContent">
    <ul class="navbar-nav mr-auto">
      <li class="nav-item">
        <button class="btn btn-default" [ngClass]="{' border border-primary' : currentScreen == 'orders'}" data-toggle="" data-target="#navbarSupportedContent" aria-controls="navbarSupportedContent" aria-expanded="false"><a class="nav-link" (click)="changeScreenToOrders()">Comenzi</a></button>

      </li>
      <li class="nav-item">
        <button class="btn btn-default" [ngClass]="{' border border-primary' : currentScreen == 'products'}" data-toggle="" data-target="#navbarSupportedContent" aria-controls="navbarSupportedContent" aria-expanded="false"><a class="nav-link" (click)="changeScreenToProducts()">Produse</a></button>

      </li>

      <li class="nav-item">
        <app-loading-screen *ngIf="isLoading"></app-loading-screen>
      </li>

    </ul>
    <form class="form-inline my-2 my-lg-0" style="padding-left: 2px; padding-right: 2px">
      <span>{{username}}</span>
    </form>
    <form class="form-inline my-2 my-lg-0" style="padding-left: 2px; padding-right: 2px">
      <button class="btn btn-warning my-2 my-sm-0" (click)="changePassword()">Schimbă Parola</button>
    </form>
    <form class="form-inline my-2 my-lg-0" style="padding-left: 2px; padding-right: 2px">
      <button class="btn btn-danger my-2 my-sm-0" (click)="logout()">Logout</button>
    </form>
  </div>
</nav>
